<template>
  <div
    class="content"
    :class="{
      'dark': dark,
      'small': small
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Content',
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  line-height: 1.25;
  font-size: 20px;
  text-align: left;
  color: $c-darktext;

  @media (min-width: 768px) {
    font-size: 24px;
  }

  p {
    margin: 1em auto;

    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  a {
    color: $c-red;

    &:hover, &:focus {
      color: $c-red;
    }
  }
}
.dark {
  color: white;
}
.small {
  font-size: 18px;
  line-height: 1.33;
}
</style>



// WEBPACK FOOTER //
// src/components/chapter/Content.vue